import { ASSET_DESKTOP } from '../elements/assets'
import { ASSETS_MOBILE } from '../elements/assets'

export const TEXT_MEDIA_MOBILE_SLIDER = `
...on textMediaMobileSlider_Entry {
  id
  typeHandle

  backgroundColor

  heading {
    html
  }
  description

  ${ ASSET_DESKTOP }
  ${ ASSETS_MOBILE }
}
`